import { createMutationHook, collapseDataFromCall } from '../client';
import { getOutstandingInvoicesForAdministrator } from '../services/InvoicesBackofficeService';

export const useInvoicesBackofficeGetOutstandingInvoicesForAdministrator = createMutationHook(
  collapseDataFromCall(getOutstandingInvoicesForAdministrator),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);
